import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Components_UserSearchBar_25368B8A } from "./UserSearchBar.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableBody, TableHead, TableRow, TableCell, Table } from "@mui/material";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

/**
 * Generic user search component which can be instantiated from anywhere
 * <param name="ptgOnly"> If the search should be only among admins/ptg employees</param>
 * <param name="exclude"> Array of user ids that for some reason should not be selectable</param>
 * <param name="onSelect"> Callback function for when the user selects a search result </param>
 */
export function UserSearchTable(userSearchTableInputProps) {
    let elems_5, elements_4, children_1, children, children_2;
    const onSelect = userSearchTableInputProps.onSelect;
    const exclude = userSearchTableInputProps.exclude;
    const ptgOnly = userSearchTableInputProps.ptgOnly;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState([]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        margin: ((((((10 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
    }], (elems_5 = [createElement(Components_UserSearchBar_25368B8A, {
        onSelect: onSelect,
        ptgOnly: ptgOnly,
    }), MuiHelpers_createElement(Table, [["size", "small"], (elements_4 = [(children_1 = singleton((children = singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "head"], ["children", ctx.Locale.t("Login.Email")]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_2 = singleton(map((a) => {
        const disabled = exclude.some((y) => (a.AccountId === y));
        return MuiHelpers_createElement(TableRow, toList(delay(() => append(singleton_1(["style", createObj(toList(delay(() => append(singleton_1(["userSelect", "none"]), delay(() => (disabled ? singleton_1(["backgroundColor", "#e1e1e1"]) : singleton_1(["cursor", "pointer"])))))))]), delay(() => append(!disabled ? singleton_1(["onClick", (_arg) => {
            onSelect(a);
        }]) : empty(), delay(() => {
            let elements_2;
            return singleton_1((elements_2 = [MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", a.Email]])], ["children", reactApi.Children.toArray(Array.from(elements_2))]));
        })))))));
    }, patternInput[0])), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_2))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

